import columns from '../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredDateTimeColumn,
    FilteredBooleanColumn,
    FilteredTextColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredDateTimeColumn('Upload Date', 'date'),
        new FilteredTextColumn('Description', 'description'),
        new FilteredTextColumn('File Name', 'fileName'),
        new FilteredTextColumn('Status', 'status'),
        new FilteredBooleanColumn('Errors', 'hasErrors'),
      ],
    },
  ];
};
